// extracted by mini-css-extract-plugin
export default {"error_container":"error_error_container__6W153","error_icon":"error_error_icon__8PdWf","error_text":"error_error_text__I6Ck2","error_inner":"error_error_inner__0hvUT"};